import { render, staticRenderFns } from "./InsecticideStatistics.vue?vue&type=template&id=2a9889af&"
import script from "./InsecticideStatistics.vue?vue&type=script&lang=js&"
export * from "./InsecticideStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports